import axios from '../utils/axios';
import {BASE_URL} from '../config';
import {fetch} from '@app/apiFunction';

export const createLeave = async (data) => {
  const result = JSON.stringify(data);
  const token = localStorage.getItem('token');
  const type = 'post';
  const url = BASE_URL + '/leave/create';
  const payload = result;
  const resp = fetch(url, type, payload, token);
  return resp;
};

export const getLeaveSummary = async ({userId}: any) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = `${BASE_URL}/leave/summary/${userId}`;
  const resp = fetch(url, type, {}, token);
  return resp;
};

export const leaveUpdate = async (data: any, leaveId: string) => {
  const result = JSON.stringify(data);
  const token = localStorage.getItem('token');
  const type = 'post';
  const url = `${BASE_URL}/leave/update/${leaveId}`;
  const payload = result;
  const resp = fetch(url, type, payload, token);
  return resp;
};

export const getMyLeaves = async (query) => {
  let requestQuery = Object.keys(query)
    .filter((v) => {
      // console.log(v,"key")
      // console.log(query[v],"value")
      return query[v] !== null;
    })
    .filter((v) => query[v] !== 0)
    .map((v) => {
      // console.log(v,"v here")
      return `${v}=${query[v]}`;
    })
    .join('&');

  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/leave/get-leave?' + requestQuery;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getAllLeaves = async (query) => {
  let requestQuery = Object.keys(query)
    .filter((v) => {
      // console.log(v,"key")
      // console.log(query[v],"value")
      return query[v] !== null;
    })
    .filter((v) => query[v] !== 0)
    .map((v) => {
      // console.log(v,"v here")
      return `${v}=${query[v]}`;
    })
    .join('&');
  // const requestQuery = "pageNo=4"
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/leave/get-all-leaves?' + requestQuery;
  const resp = fetch(url, type, null, token);
  return resp;
};

export const getAllAdminName = async () => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/user/get-all-admin';
  const resp = fetch(url, type, null, token);
  return resp;
};

export const deleteLeave = async (id) => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/leave/delete/' + id;

  const resp = fetch(url, type, null, token);
  return resp;
};

export const fetchAllLeaveDetails = async () => {
  const token = localStorage.getItem('token');
  const type = 'get';
  const url = BASE_URL + '/leave/all-details';
  const resp = fetch(url, type, null, token);
  return resp;
};
